import Popover from 'bootstrap/js/src/popover'
export default class popover {
    constructor (element) {
        this.element = element
        this.content = this.element.nextElementSibling.querySelector('[data-name="popover-content"]')

        this.config = {
            html: true,
            trigger: 'manual',
            content: this.content
        }

        this.element.addEventListener('click', this.handleClick.bind(this))
        this.element.addEventListener('focusout', () => this.popover.hide())
        this.popover = new Popover(this.element, this.config)
    }

    handleClick () {
        this.popover.toggle()
    }
}
